import { ClockCircleOutlined, MobileOutlined } from "@ant-design/icons";
import { BodhiButton, BodhiTag } from "@bodhistreams/ui";
import { formatDate } from "@bodhistreams/utils/src/dateTime";
import { formatPrice } from "./profileUtils";
import "./SubscriptionCard.css";

const SubscriptionCard = ({
	stripeDetails,
	hasStreamingLimit,
	streamingLimit,
	monthlyStreamHours,
	usagePercentage,
	isOverLimit,
	devices,
	isManagingSubscription,
	onManageSubscription,
}) => {
	return (
		<div className="profile-card bodhi-card">
			<div className="profile-card-head">
				<h2 className="profile-card-title">Subscription & Usage</h2>
				<BodhiButton
					variant="ghost"
					size="sm"
					onClick={onManageSubscription}
					loading={isManagingSubscription}
				>
					Manage
				</BodhiButton>
			</div>

			<div className="profile-sub-top">
				<div>
					<span className="profile-row-label">Current Plan</span>
					<span className="profile-plan-name">
						{stripeDetails.product_name || "No Plan"}
					</span>
					{stripeDetails.cancel_at_period_end && (
						<div style={{ marginTop: 6 }}>
							<BodhiTag color="amber">
								{stripeDetails.current_period_end
									? `Cancels on ${formatDate(stripeDetails.current_period_end)}`
									: "Cancels at period end"}
							</BodhiTag>
						</div>
					)}
				</div>
				<div className="profile-plan-col-right">
					<span className="profile-row-label">Price</span>
					<span className="profile-price">
						{stripeDetails.price
							? formatPrice(stripeDetails.price, stripeDetails.billing_period)
							: "Free"}
					</span>
					{stripeDetails.billing_period === "yearly" && (
						<div className="profile-billing-note">
							≈ ${(stripeDetails.price / 12).toFixed(2)}/month
						</div>
					)}
				</div>
			</div>

			{hasStreamingLimit && (
				<div className="profile-usage">
					<div className="profile-usage-head">
						<span>Streaming Usage</span>
						<span>
							{monthlyStreamHours.toFixed(1)}h / {streamingLimit}h
						</span>
					</div>
					<div className="profile-usage-bar">
						<div
							className={`profile-usage-fill${isOverLimit ? " is-over" : ""}`}
							style={{ width: `${usagePercentage}%` }}
						/>
					</div>
					{isOverLimit && (
						<p className="profile-error">
							You've exceeded your monthly streaming limit
						</p>
					)}
				</div>
			)}

			<div>
				<span className="profile-section-label">Plan Features</span>
				<div className="profile-features">
					<div className="profile-feature">
						<MobileOutlined className="profile-feature-icon" />
						<span>
							{devices} simultaneous device{devices !== 1 ? "s" : ""}
						</span>
					</div>
					<div className="profile-feature">
						<ClockCircleOutlined className="profile-feature-icon" />
						<span>
							{hasStreamingLimit
								? `${streamingLimit} hours/month`
								: "Unlimited streaming"}
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SubscriptionCard;
